import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      btnSendCode: formatMessage(messages.btnSendCode),
    };
  }, [formatMessage]);

  return translations;
};

export default useTranslations;
